export const ACCOUNT_PREFERENCES = 'ACCOUNT_PREFERENCES';
export const AUTHENTICATED_PREFERENCES = 'AUTHENTICATED_PREFERENCES';
export const LOCATIONS_PREFERENCES = 'LOCATIONS_PREFERENCES';
export const PUBLIC_PREFERENCES = 'PUBLIC_PREFERENCES';
export const USER_PREFERENCES = 'USER_PREFERENCES';



// WEBPACK FOOTER //
// ./src/actions/preferences/types.js